// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".acordion-like-enter-active[data-v-7c5f72e2],.acordion-like-leave-active[data-v-7c5f72e2]{overflow:hidden}.acordion-like-enter-active[data-v-7c5f72e2]{transition:all 1.5s ease 0s}.acordion-like-leave-active[data-v-7c5f72e2]{transition:all .5s ease 0s}.acordion-like-enter[data-v-7c5f72e2],.acordion-like-leave-to[data-v-7c5f72e2]{max-height:0}.acordion-like-enter-to[data-v-7c5f72e2],.acordion-like-leave[data-v-7c5f72e2]{max-height:2000px}", ""]);
// Exports
module.exports = exports;
